import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('CAN_UPLOAD_USER_MANUAL')